import AddStockUtil from "Components/Pages/Gdev/Trading/AddStockUtil";

export function makeAddStockFormatData({ data, ClientCode, EmployeeCode }) {
  const result = data?.items?.map((item) => {
    const stones = item?.Stones?.length
      ? item?.Stones?.map((sitem) => {
          return {
            ...sitem,
            StoneAmount: `${(+(sitem?.StoneAmount || 0))?.toFixed(2)}`,
          };
        })
      : [];
      
    return {
      HSNCode:item?.HSNCode,
      CategoryId: item?.CategoryId?.value,
      ProductId: item?.ProductId?.value,
      DesignId: item?.DesignId?.value,
      PurityId: item?.PurityId?.value,
      CollectionId: item?.CollectionId?.value,
      PacketId: item?.PacketId?.value,
      BoxId: item?.BoxId?.value,
      WeightCategory: item?.WeightCategory?.value,
      Quantity: item?.Quantity,
      TotalWeight: (+(item?.TotalWeight || 0))?.toFixed(3),
      PackingWeight: (+(item?.PackingWeight || 0))?.toFixed(3),
      GrossWt: (+(item?.GrossWt || 0))?.toFixed(3),
      TotalStoneWeight: (+(item?.TotalStoneWeight || 0))?.toFixed(3),
      NetWt: (+(item?.NetWt || 0))?.toFixed(3),
      Pieces: "" + (item?.Pieces || ""),
      MakingPercentage: (+(item?.MakingPercentage || 0))?.toFixed(3),
      MakingPerGram: (+(item?.MakingPerGram || 0))?.toFixed(3),
      MakingFixedAmt: (+(item?.MakingFixedAmt || 0))?.toFixed(3),
      MakingFixedWastage: (+(item?.MakingFixedWastage || 0))?.toFixed(3),
      MRP: (+(item?.MRP || 0))?.toFixed(3),
      ClipWeight: (+(item?.ClipWeight || 0))?.toFixed(3),
      ClipQuantity: "" + +(item?.ClipQuantity || ""),

      ProductCode:`${item?.ProductCode && item?.ProductCode != "undefined" ? item?.ProductCode : ""}` ,
      Featured:item?.Featured||"",
      ProductTitle:item?.ProductTitle||"",
      Description: item?.Description || "",

      Gender: item?.Gender,
      DiamondId: item?.DiamondName?.value || "",
      DiamondName: item?.DiamondName?.label || "",
      DiamondShape: item?.DiamondShape?.value || "",
      DiamondShapeName: item?.DiamondShape?.label || "",
      DiamondClarity: item?.DiamondClarity?.value || "",
      DiamondClarityName: item?.DiamondClarity?.label || "",
      DiamondColour: item?.DiamondColour?.value || "",
      DiamondColourName: item?.DiamondColour?.label || "",
      DiamondSleve: item?.DiamondSleve || "",
      DiamondSize: item?.DiamondSize || "",
      DiamondSellRate: item?.DiamondSellRate || "",
      DiamondWeight: item?.DiamondWeight || "",
      DiamondCut: `${item?.DiamondCut?.value}` || "",
      DiamondCutName: item?.DiamondCut?.label || "",
      DiamondSettingType: `${item?.DiamondSettingType?.value}` || "",
      DiamondSettingTypeName: item?.DiamondSettingType?.label || "",
      DiamondCertificate: item?.DiamondCertificate || "",
      DiamondDescription: item?.DiamondDescription || "",
      DiamondPacket: item?.DiamondPacket || "",
      DiamondBox: item?.DiamondBox || "",
      DiamondWeight: `${(+(item?.DiamondWeight) || 0)?.toFixed(3)}`,
      DiamondPieces: `${item?.DiamondPieces || ""}`,
      Stones: stones?.length ? stones : [],
      DButton: "",
      StoneName: "",
      StoneShape: "",
      StoneSize: "",
      StoneWeight: (+(item?.TotalStoneWeight || 0))?.toFixed(3),
      StonePieces: `${item?.StonePieces || 0}`,
      StoneRatePiece: "",
      StoneRateKarate: "",
      StoneAmount: "",
      StoneDescription: "",
      StoneCertificate: "",
      StoneSettingType: "",
      // ItemCode:"",
      BranchName: item?.Branch?.label,
      BranchId: item?.Branch?.value,
      // VendorName: item?.VendorId?.label,
      VendorId: item?.VendorId?.value,
      SKU: item?.SKUId?.label,
      SKUId: item?.SKUId?.value,
      // ProductName: item?.ProductName,
      // CategoryName: item?.CategoryId?.label,
      PurityName: item?.PurityId?.label,
      // DesignName: item?.DesignId?.label,
      CollectionNameSKU: item?.CollectionId?.label,
      PacketName: item?.PacketId?.label,
      BoxName: item?.BoxId?.label,
      LotNumber: item?.LotNumber?.label,
      TotalStoneAmount: item?.TotalStoneAmount,
      TotalStonePieces: `${item?.StonePieces || 0}`,
      ClientCode: ClientCode,
      EmployeeCode: EmployeeCode,
      StoneColour: "",
      CompanyId: 0,
      CounterId: 0,
      MetalId: 1,
      WarehouseId: 0,
      RFIDCode: (item?.RFIDCode || "")?.toUpperCase(),
      TIDNumber: item?.TIDNumber,
      grosswt: (+(item?.GrossWt || 0))?.toFixed(3),
      TotalDiamondWeight: `${(+(item?.DiamondWeight) || 0)?.toFixed(3)}`,
      TotalDiamondAmount: item?.DiamondAmount || "",
      Status: "Active",
    };
  });
  return result;
}

export function makeUpdateStockFormatData({ data, ClientCode, EmployeeCode }) {
  const result = data?.items?.map((item) => {
    const stones = item?.Stones?.length
      ? item?.Stones?.map((sitem) => {
          return {
            ...sitem,
            StoneAmount: `${(+(sitem?.StoneAmount || 0))?.toFixed(2)}`,
          };
        })
      : [];

      let images = "" 
      item?.Images?.forEach((item)=>item?.file == null && (images += item?.preview)) 
    return {
      ...item,
      CategoryId: item?.CategoryId?.value,
      ProductId: item?.ProductId?.value,
      DesignId: item?.DesignId?.value,
      PurityId: item?.PurityId?.value,
      SKUId:item?.SKUId?.value,
      SKU:item?.SKUId?.label,
      Stones:stones,
      TotalStoneWeight:`${(+(item?.TotalStoneWeight || 0))?.toFixed(3)}`,
      VendorId:item?.VendorId?.value,
      VendorName:item?.VendorId?.VendorName,
      StonePieces: `${item?.StonePieces || 0}`,
      StoneWeight: (+(item?.TotalStoneWeight || 0))?.toFixed(3),
      DiamondPieces: `${item?.DiamondPieces || ""}`,
      DiamondWeight: `${(+(item?.DiamondWeight) || 0)?.toFixed(3)}`,
      TotalStoneWeight: (+(item?.TotalStoneWeight || 0))?.toFixed(3),
      TotalDiamondWeight: `${(+(item?.DiamondWeight) || 0)?.toFixed(3)}`,
      TotalStonePieces: `${item?.StonePieces || 0}`,

      ProductCode:`${item?.ProductCode}` || "",
      Featured:item?.Featured||"",
      ProductTitle:item?.ProductTitle||"",
      Description: item?.Description || "",
      
      Images:images
         };
  });
  return result;
}
